import {Component, OnInit}        from '@angular/core';
import {ErrorNotifierService} from '../error-notifier/error.notifier';
import {LoginService} from '../login/login.service';

import myGlobals = require('../config');
import * as io from "socket.io-client";
declare var $: any;

@Component({
    selector: 'Error',
    template: require('../../app/error/error.component.html'),
    styles: [require('../../app/error/error.component.css')]
})
export class ErrorComponent implements OnInit {
    error: any;
    message: string;
    segundoModal: boolean;
    socket: any;

    constructor(private errorNotifierService: ErrorNotifierService, private loginService: LoginService) {
        this.error = [];
        this.message = "";
        this.segundoModal = false;
        //$("#modalErrores").modal("show");
        //Conectar al socket con configuración específica
        this.socket = io.connect(myGlobals.default.URL_MQTT, { 
            path: myGlobals.default.PATH_MQTT,
            transports: ['websocket', 'polling'], // Priorizar websocket
            upgrade: true,
            rememberUpgrade: true
        });

        // Debug de conexiones
        this.socket.on('connect', () => {
            console.log('Socket error conectado via:', this.socket.io.engine.transport.name);
            $('#online').css("display", "none");
            this.socket.io.engine.on('upgrade', () => {
                console.log('Socket error actualizado a:', this.socket.io.engine.transport.name);
            });
        });

        this.socket.on('connect_error', function () {
            $('#online').css("display", "block");
        });

    }

    ngOnInit() {

        //Suscribir al error notifier
        this.errorNotifierService.onError(value => {
            this.error = "";
            this.message = "";
            if (value.status == 401) {
                this.loginService.logout();
            }
            else {

                this.error = $.map(JSON.parse(value._body).errors, function (el) {
                    return el
                });
                if (JSON.parse(value._body).name != "ValidationError")
                    this.message = JSON.parse(value._body).message;
                $("#modalErrores").modal("show");
            }
        });

        this.errorNotifierService.onOk(() => {
            $("#modalOk").modal("show");
        });

        //Corregir dos modales uno encima del otro
        $(document).on('show.bs.modal', '.modal', function () {
            var zIndex = 1040 + (10 * $('.modal:visible').length);
            $(this).css('z-index', zIndex);
            setTimeout(function() {
                $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
            }, 0);
        });
    }

    closeModal() {
        $("#modalErrores").modal("hide");
        //Corregir scroll cuando hay dos modales uno encima del otro
        $(document).on('hidden.bs.modal', '.modal', function () {
            $('.modal:visible').length && $(document.body).addClass('modal-open');
        });
    }

    ngOnDestroy() {
        this.socket.disconnect();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/error/error.component.ts